<nav-bar
    titulo="Administração CDT"
    [iconeNotificacoes]="false"
    [botaoMenu]="true"
    [botaoPainelAplicacoes]="true"
    [linkPainelAplicacoes]="URL_LOGIN"
    (logoutEvent)="logout($event)"
></nav-bar>
<menu-lateral [itensMenu]="menuItens">
    <copyright></copyright>
</menu-lateral>
